module.exports = __webpack_public_path__ + "public/files/img/manual.dd93490a.png";